<template>
  <div>
    <Header msg="member" />

    <div class="container mt-5 clickview">
      <div>
        <h5>Chọn tháng muốn thống kê</h5>
      </div>
      <div>
        <select name="" id="" v-model="currentMonth">
          <option value="12">12</option>
          <option value="11">11</option>
          <option value="10">10</option>
          <option value="9">9</option>
          <option value="8">8</option>
          <option value="7">7</option>
          <option value="6">6</option>
          <option value="5">5</option>
          <option value="4">4</option>
          <option value="3">3</option>
          <option value="2">2</option>
          <option value="1">1</option>
        </select>
      </div>
      <div>
        <button class="" @click="clickview()">Xem</button>
      </div>
    </div>
    <!-- dashboard -->
    <!-- start -->
    <div class="container" v-bind:class="{ active: isActive }">
      <div class="row ros">
        <div>
          <p>Doanh thu đơn duyệt</p>
          <h2>{{ tongTien }}</h2>
        </div>
        <div>
          <p>Tổng đơn</p>
          <h2>{{ tongDonHang }}</h2>
        </div>
        <div>
          <p>Tổng số đơn chờ</p>
          <h2>{{ tongDonCho }}</h2>
        </div>
        <div>
          <p>Tổng số đơn duyệt</p>
          <h2>{{ tongDonDuyet }}</h2>
        </div>
      </div>
      <div class="row ros">
        <div>
          <p>Tổng đơn Chưa có TT phát</p>
          <h2>{{ x1 }}</h2>
        </div>
        <div>
          <p>Tổng đơn Chưa phát được</p>
          <h2>{{ x2 }}</h2>
        </div>
        <div>
          <p>Tổng đơn Đã phát thành công</p>
          <h2>{{ x3 }}</h2>
        </div>
        <div>
          <p>Tổng đơn Phát hoàn thành công</p>
          <h2>{{ x4 }}</h2>
        </div>
      </div>
    </div>
    <!-- end -->

    <div class="container mt-5 res" v-bind:class="{ active: isActive }">
      <table class="table">
        <tr>
          <td>#</td>
          <td>ID</td>
          <td>Họ và tên</td>
          <td>Đơn duyệt</td>
          <td>Tổng tiền</td>
        </tr>
        <tr v-for="(e, i) in taiKhoan" :key="i">
          <td>{{ i }}</td>
          <td>{{ e.id }}</td>
          <td>{{ e.name }}</td>
          <td>{{ e.count }}</td>
          <td>{{ e.money }}</td>
        </tr>
      </table>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";
export default {
  components: { Header, Footer },
  data() {
    return {
      isActive: true,
      currentMonth: 0,
      tongTien: 0,
      tongDonHang: 0,
      tongDonCho: 0,
      tongDonDuyet: 0,
      donCho: null,
      donDuyet: null,
      donHang: null,
      taiKhoan: null,
      x1: 0,
      x2: 0,
      x3: 0,
      x4: 0,
    };
  },

  methods: {
    clickview() {
      (async () => {
        this.taiKhoan = await axios
          .get(
            "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Accounts"
          )
          .then((response) => {
            return response.data.filter((e) => {
              e.count = 0;
              e.money = 0;
              return (
                e.active == "on" &&
                (e.owned == sessionStorage.getItem("id") ||
                  e.id == sessionStorage.getItem("id"))
              );
            });
          });

        this.donHang = await axios
          .get(
            "https://sheet.best/api/sheets/98958532-8ddf-478a-b977-9f68a6bf7d7b/tabs/Orders"
          )
          .then((response) => {
            return response.data.filter((e) => {
              return (
                parseInt(e.date.substr(3, 2)) == this.currentMonth &&
                parseInt(e.date.substr(6, 4)) == new Date().getFullYear() &&
                (e.owned == sessionStorage.getItem("id") ||
                  e.ctv == sessionStorage.getItem("id"))
              );
            });
          });

        this.x1 = this.donHang.filter(e=>{
          return e.ctv_id == "Chưa có TT phát";
        }).length

        this.x2 = this.donHang.filter(e=>{
          return e.ctv_id == "Chưa phát được";
        }).length

        this.x3 = this.donHang.filter(e=>{
          return e.ctv_id == "Đã phát thành công";
        }).length

        this.x4 = this.donHang.filter(e=>{
          return e.ctv_id == "Phát hoàn thành công";
        }).length

        this.tongDonHang = this.donHang.length; // tong don hang

        this.donCho = this.donHang.filter((e) => {
          return e.status == "no";
        });

        this.tongDonCho = this.donCho.length; // tong don cho

        this.donDuyet = this.donHang.filter((e) => {
          return e.status == "yes";
        });

        this.tongDonDuyet = this.donDuyet.length; // tong don duyet

        this.taiKhoan.forEach((e) => {
          this.donDuyet.forEach((element) => {
            if (e.id == element.owned) {
              e.money += parseInt(element.note);
              e.count++;
            }
          });
          e.money = currency(e.money * 1000).format();
        });

        this.taiKhoan = this.taiKhoan.filter((e) => {
          return e.count != 0 && e.money != "$0.00";
        });

        this.tongTien = 0;

        this.donDuyet.forEach((e) => {
          this.tongTien += parseInt(e.note);
        });

        this.tongTien = currency(this.tongTien * 1000).format();

        if (this.currentMonth != 0) {
          this.isActive = false;
        }
      })();
    },
  },
};
</script>

<style lang="css" scoped>
.ros {
  margin-top: 5rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.ros > div {
  background-color: #2ecc71;
  width: 24%;
  text-align: center;
  padding: 1rem;
  box-shadow: 0 8px 32px rgba(127, 127, 158, 0.2);
  color: white;
  border-radius: 4px;
  border-left: 2rem solid #27ae60;
}
.ros > div:first-child {
  background-color: #f1c40f;
  border-left: 2rem solid #f39c12;
}
.ros > div:nth-child(2) {
  background-color: #e74c3c;
  border-left: 2rem solid #c0392b;
}
.ros > div:last-child {
  background-color: #3498db;
  border-left: 2rem solid #2980b9;
}
.active {
  display: none;
}
.clickview {
  background: #ecf0f1;
  /* background: white; */
  display: flex;
  padding: 1rem;
  border-radius: 5px;
  /* box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1); */
}
.clickview h5 {
  margin-top: 0.5rem;
  margin-left: 1rem;
}
.clickview > div select {
  margin-left: 1rem;
  border-radius: 0;
  border: 1px solid #27ae60;
  padding: 0.5rem 1rem;
  outline: none;
}
.clickview > div button {
  border: 0;
  background: #2ecc71;
  color: white;
  padding: 0.5rem 1rem;
  outline: none;
  cursor: pointer;
}
.res {
  height: 20rem;
  overflow: auto;
}
@media screen and (max-width: 768px) {
  .ros {
    display: flex;
  }
  .ros > div {
    width: 100%;
    margin: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MemberReport.vue